var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.4316 7.26458C29.6602 7.08698 30 7.25313 30 7.53385V19.25C30 20.7682 28.7402 22 27.1875 22H2.8125C1.25977 22 0 20.7682 0 19.25V7.53958C0 7.25313 0.333984 7.09271 0.568359 7.27031C1.88086 8.26719 3.62109 9.53333 9.59766 13.7786C10.834 14.6609 12.9199 16.5172 15 16.5057C17.0918 16.5229 19.2188 14.6266 20.4082 13.7786C26.3848 9.53333 28.1191 8.26146 29.4316 7.26458ZM15 14.6667C16.3594 14.6896 18.3164 12.9938 19.3008 12.2948C27.0762 6.7776 27.668 6.29635 29.4609 4.92135C29.8008 4.66354 30 4.2625 30 3.83854V2.75C30 1.23177 28.7402 0 27.1875 0H2.8125C1.25977 0 0 1.23177 0 2.75V3.83854C0 4.2625 0.199219 4.65781 0.539062 4.92135C2.33203 6.29062 2.92383 6.7776 10.6992 12.2948C11.6836 12.9938 13.6406 14.6896 15 14.6667Z"}));
}

Mail.defaultProps = {"width":"30","height":"22","viewBox":"0 0 30 22","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
